module.exports = __webpack_public_path__ + "static/img/paymentFailed.dc242766.png";